jQuery(function($)
{
    var
        api = orion.api.newsletter,
        $body = $('body'),
        $newsletterSwitch = $('#doubleoptin-newsletter'),
        $submitNewEmail = $('.js-submit-new-email'),
        $submitNewEmailDialog = $('.js-submit-new-email-dialog'),
        $newsletterEmailSubscriptionButton = $('#newsletter-email-subscription-button');

    function triggerNewsletterToggle(e)
    {
        e.preventDefault();

        // var $email = $("#email-address").val(); todo use email address from form
        var $email = $newsletterSwitch.data('customer-email');

        if (!$newsletterSwitch.is(':checked'))
        { // Note: checkboxes seem to work weird in that way; state = AFTER click
            api.unsubscribeNewsletter({
                'email' : $email
            }).done(function()
            {
                $newsletterSwitch.prop('checked', false);
            })
                .fail(function()
                {
                    //            $newsletterSwitch.prop('disabled', true);
                });
        }
        else
        {
            api.subscribeNewsletter({
                'email' : $email
            }).done(function()
            {
                $newsletterSwitch.prop('checked', true);
            })
                .fail(function()
                {
                    //          $newsletterSwitch.prop('disabled', true);
                });
        }
    }

    function handleNewsletterEmailSubscription(event)
    {
        event.preventDefault();

        var
            email = $('#newsletter-email-subscription-email').val(),
            language = $('#newsletter-email-subscription-language').val(),
            feedbackNewsletterAjaxSuccess = $('meta[itemprop="feedback-newslettter-ajax-success"]').attr('content'),
            feedbackNewsletterAjaxError = $('meta[itemprop="feedback-newslettter-ajax-error"]').attr('content');

        api.subscribeNewsletter({
            'email' : email,
            'language' : language
        }).done(function()
        {
            $body.append('<div class="js-feedback js-feedback-autohide feedback success">'
				+ '<i class="fa-regular fa-check"></i><p>'
				+ feedbackNewsletterAjaxSuccess + '</p><a href="#" class="close"><i class="fa-regular fa-times">'
				+ '</i></a></div>');
            $body.trigger('feedback-added');
        })
            .fail(function()
            {
                $body.append('<div class="feedback error js-feedback">'
					+ '<i class="fa-regular fa-exclamation-circle"></i><p>'
					+ feedbackNewsletterAjaxError + '</p><a href="#" class="close"><i class="fa-regular fa-times">'
					+ '</i></a></div>');
                $body.trigger('feedback-added');
            });
    }

    function handleSubmitOfNewAccountEmailAddress(event)
    {
        var inputEmail = $('#login-email').val();
        var oldEmail = $('#storedEmailAddress').text();

        console.log('Email: ' + inputEmail);
        console.log('StoredEmail: ' + oldEmail);
        if (($('#newsletterSubscriptionStatus').text() == '1') && (inputEmail != oldEmail))
        {
            event.preventDefault();
            $('#overlay-new-email-subscription').removeClass('hidden');
            $('body').addClass('focus-active');
        }
    }

    function saveNewAccountEmailSubscriptionDialogChoice()
    {
        console.log(2);
        var oldEmail = $('#storedEmailAddress').text();
        var inputEmail = $('#login-email').val();

        $('#newEmailSubscription').val(inputEmail);
        var feedbackNewsletterAjaxSuccess = $('meta[itemprop="feedback-newslettter-ajax-success"]').attr('content'),
            feedbackNewsletterAjaxError = $('meta[itemprop="feedback-newslettter-ajax-error"]').attr('content');
        var newEmailSubscriptionChoice = $('input[name="newEmailSubscriptionChoice"]:checked').val();

        switch (newEmailSubscriptionChoice)
        {
        case 'toBoth':
            api.subscribeNewsletter({
                'email' : inputEmail
            }).done(function()
            {
                $body.append('<div class="js-feedback js-feedback-autohide feedback success">'
						+ '<i class="fa-regular fa-check"></i>'
						+ '<p>'
						+ feedbackNewsletterAjaxSuccess + '</p><a href="#" class="close">'
						+ '<i class="fa-regular fa-times"></i></a></div>');
                $body.trigger('feedback-added');
                $('#overlay-new-email-subscription').addClass('hidden');
                $('body').removeClass('focus-active');
            })
                .fail(function()
                {
                    $body.append('<div class="feedback error js-feedback">'
							+ '<i class="fa-regular fa-exclamation-circle"></i>'
							+ '<p>'
							+ feedbackNewsletterAjaxError
							+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
                    $body.trigger('feedback-added');
                });
            break;
        case 'onlyToNew':
            api.unsubscribeNewsletter({
                'email' : oldEmail
            }).done(function()
            {
                api.subscribeNewsletter({
                    'email' : inputEmail
                }).done(function()
                {
                    $body.append('<div class="js-feedback js-feedback-autohide feedback success">'
							+ '<i class="fa-regular fa-check"></i>'
							+ '<p>'
							+ feedbackNewsletterAjaxSuccess
							+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
                    $body.trigger('feedback-added');
                    $('#overlay-new-email-subscription').addClass('hidden');
                    $('body').removeClass('focus-active');
                })
                    .fail(function()
                    {
                        $body.append('<div class="feedback error js-feedback">'
								+ '<i class="fa-regular fa-exclamation-circle"></i>'
								+ '<p>'
								+ feedbackNewsletterAjaxError
								+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
                        $body.trigger('feedback-added');
                    });
            })
                .fail(function()
                {
                    $body.append('<div class="feedback error js-feedback">'
							+ '<i class="fa-regular fa-exclamation-circle"></i>'
							+ '<p>'
							+ feedbackNewsletterAjaxError
							+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
                    $body.trigger('feedback-added');
                });
            break;
        case 'noChange':
            $('#overlay-new-email-subscription').addClass('hidden');
            $('body').removeClass('focus-active');
            break;
        default:
            $('#overlay-new-email-subscription').addClass('hidden');
            $('body').removeClass('focus-active');
        }
    }

    $newsletterSwitch.on('click', triggerNewsletterToggle);
    $newsletterEmailSubscriptionButton.on('click', handleNewsletterEmailSubscription);
    $submitNewEmail.on('click', handleSubmitOfNewAccountEmailAddress);
    $submitNewEmailDialog.on('click', saveNewAccountEmailSubscriptionDialogChoice);
});
